import React from 'react';
import { useNavigate } from 'react-router-dom';

const VendorProductCard = ({ product, addToCart }) => {
  const navigate = useNavigate();
  const handleEditClick = () => {
    navigate(`/producto-vendedor/${product.id}`, { state: { product } });
  };  
  return (
    <div className="col mb-4">
      <div className="card h-100 shadow-sm border-0 rounded-4">
        
        {/* boton de stock en verde como la de inicio */}
        <div 
          className="badge bg-success text-white position-absolute px-3 py-2 rounded-pill" 
          style={{ top: "0.8rem", right: "0.8rem", fontSize: "0.8rem" }}
        >
          Stock: {product.Stock}
        </div>

        {/* imagen del producto */}
        <img 
          className="card-img-top rounded-top-4" 
          src={product.Image} 
          alt={product.name} 
          style={{ objectFit: "cover", height: "220px" }}
        />

        {/* info */}
        <div className="card-body p-4 text-center">
          <h5 
            className="fw-bold mb-2" 
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            {product.name}
          </h5>

          {/* estrellas */}
          <div className="d-flex justify-content-center small text-warning mb-3">
            {Array.from({ length: product.Estrellas }).map((_, index) => (
              <i key={index} className="bi bi-star-fill me-1"></i>
            ))}
          </div>

          {/* precio en azul como inicio */}
          <span className="fw-semibold text-primary fs-5">
            S/. {product.price}
          </span>
        </div>

        {/* boton azul con letras blancas como inicio tmb */}
        <div className="card-footer p-3 border-top-0 bg-transparent text-center">
          <button 
            className="btn btn-primary px-4 rounded-pill shadow-sm text-white"
            onClick={() => handleEditClick(product)}
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            ✏️ Modificar Producto
          </button>

        </div>
      </div>
    </div>
  );
};

export default VendorProductCard;
